import Immutable from 'seamless-immutable'
import { supportConstants } from '../constants'

const initialState = Immutable({
  supportLoading: false,
  supportContent: [],
})

const supportReducer = (state = initialState, action) => {
  switch (action.type) {
    case supportConstants.SUPPORT_REQUEST:
      return {
        ...state,
        supportLoading: true,
      }

    case supportConstants.SUPPORT_SUCCESS: {
      const {
        response: { payload: supportContent },
      } = action

      return {
        ...state,
        supportContent: Array.isArray(supportContent) ? supportContent : [],
        supportLoading: false,
      }
    }

    case supportConstants.SUPPORT_SET_ACTIVE: {
      const getFaqIndex = (index, inputArray, keyword) => {
        for (let i = 0; i < inputArray.length; i++) {
          if (inputArray[i].faqId === index && inputArray[i].keyword === keyword) {
            return i
          }
        }
      }
      const {
        body: { index, keyword },
      } = action
      const faqIndex = getFaqIndex(index, state.supportContent, keyword)
      const {
        supportContent: {
          [faqIndex]: { isOpen },
        },
      } = state

      return {
        ...state,
        supportContent: [
          ...state.supportContent.slice(0, faqIndex),
          {
            ...state.supportContent[faqIndex],
            isOpen: !isOpen,
          },
          ...state.supportContent.slice(faqIndex + 1),
        ],
      }
    }

    default:
      return state
  }
}

export default supportReducer
